module.exports = __webpack_public_path__ + "img/access.27a9511c.png";